<template>
    <StfCard>
        <template #title>
            <ApplicationStepHeader title="Payment Received!" />
        </template>
        <template #content>
            <div class="success-content">
                <StfSheet class="my-3">
                    <div class="has-text-centered">
                        <div class="mb-6">
                            <img src="/img/image-success.svg" alt="Success" class="success-image" />
                        </div>
                        <StfInfoText class="mb-2">
                            Your {{ country.name }} trademark application will be submitted to the Trademark Office in one business day.
                            <br/>
                            Please check your emails for our order confirmation and payment receipt/tax invoice.
                        </StfInfoText>
                        <StfInfoText class="mb-2">
                            Thanks for using {{ domain.name }}.
                        </StfInfoText>
                    </div>
                </StfSheet>
            </div>
        </template>
    </StfCard>
    <StfButton class="mt-4 full-width-button" @click="showModal = true">
        APPLY FOR ANOTHER TRADEMARK
    </StfButton>

    <StfDialog v-model="showModal" minHeight="100px">
        <template #title>
            <StfHeading>Apply for another trademark</StfHeading>
        </template>
        <StfInfoText class="mb-2 mt-2">
            Are the trademark details similar to your last?
        </StfInfoText>
        <template #actions>
            <StfRow>
                <StfCol col="12" colDesktop="6">
                    <StfButton color="text" class="w-100" @click="handleSimilarResponse(false)">NO, COMPLETELY DIFFERENT</StfButton>
                </StfCol>
                <StfCol col="12" colDesktop="6">
                    <StfButton  class="w-100" @click="handleSimilarResponse(true)">YES, SIMILAR</StfButton>
                </StfCol>
            </StfRow>
        </template>
    </StfDialog>
</template>

<script setup lang="ts">
import ApplicationStepHeader from '@/components/common/application-step-header.vue';
import useCountry from '@/composables/countryDependable';
import { ref, onMounted, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import RouteName from '@/router/route-name';
import { resetAllStores, useImportData } from '@/store/store-utils';
import { useProductStore } from '@/store/good';
import { useOwnerStore } from '@/store/owner';
import { useContactStore } from '@/store/contact';
import { useTermOfUseStore } from '@/store/terms-of-use';
import useDomain from '@/composables/domainDependable';

const country = useCountry();
const domain = useDomain();
const showModal = ref(false);
const router = useRouter();
const savedApplicationData = ref<any>(null);

const productStore = useProductStore();
const ownerStore = useOwnerStore();
const contactStore = useContactStore();
const termOfUseStore = useTermOfUseStore();
const {importDataAllStores} = useImportData();

onMounted(() => {
    // Save the current application data before resetting
    savedApplicationData.value = {
        product: productStore.exportData(),
        owner: ownerStore.exportData(),
        contact: contactStore.exportData(),
        termOfUse: termOfUseStore.exportData()
    };
    
    nextTick(() => {
        resetAllStores();
    });
});

const handleSimilarResponse = (isSimilar: boolean) => {
    showModal.value = false;
    if (isSimilar && savedApplicationData.value) {
        importDataAllStores(savedApplicationData.value);
    }
    router.push({ name: RouteName.APPLICATION_PROCESS });
};
</script>

<style scoped>
.success-image {
    width: 64px;
    height: 64px;
}

.full-width-button {
    width: 100%;
    height: 50px;
}
</style> 